import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function uuidLike() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getVisitorId() {
  let id = localStorage.getItem('amg_visitor_id');
  if (!id) {
    id = uuidLike();
    localStorage.setItem('amg_visitor_id', id);
  }
  return id;
}

function getDeviceType() {
  const w = window.innerWidth;
  if (w < 768) return 'mobile';
  if (w < 1100) return 'tablet';
  return 'desktop';
}

function getBrowser() {
  const ua = navigator.userAgent;
  if (ua.includes('Chrome') && !ua.includes('Edg')) return 'Chrome';
  if (ua.includes('Safari') && !ua.includes('Chrome')) return 'Safari';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Edg')) return 'Edge';
  return 'Other';
}

/* Capture UTM params + referrer ONCE per session (first-touch attribution),
   persisted in localStorage so it survives across pages until form submit. */
export function captureAttribution() {
  const params = new URLSearchParams(window.location.search);
  const hasUtm = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].some(k => params.get(k));
  const existing = localStorage.getItem('amg_attribution');
  if (hasUtm || !existing) {
    const attribution = {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_content: params.get('utm_content') || '',
      utm_term: params.get('utm_term') || '',
      referrer: document.referrer || '',
      landing_page: window.location.pathname,
    };
    localStorage.setItem('amg_attribution', JSON.stringify(attribution));
    return attribution;
  }
  try { return JSON.parse(existing); } catch { return {}; }
}

export function getAttribution() {
  try { return JSON.parse(localStorage.getItem('amg_attribution') || '{}'); } catch { return {}; }
}

export function track(eventType, meta = {}, page = null) {
  const payload = {
    event_type: eventType,
    page: page || window.location.pathname,
    meta,
    visitor_id: getVisitorId(),
    language: localStorage.getItem('amg_lang') || 'en',
    device_type: getDeviceType(),
  };
  axios.post(`${API}/track`, payload).catch(() => {});
}

export function buildLeadAttribution() {
  const attribution = getAttribution();
  return {
    ...attribution,
    page_path: window.location.pathname,
    device_type: getDeviceType(),
    browser: getBrowser(),
    visitor_id: getVisitorId(),
    campaign_page: window.location.pathname,
  };
}
